var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 63,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 62,
    rx: 9.5,
    stroke: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.25 24.75a60.072 60.072 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V24.75M40.75 10.5v.75A.75.75 0 0 1 40 12h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H57.25m-18 1.5v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m-18-1.5v.375a1.125 1.125 0 0 0 1.125 1.125h.375m-1.5-1.5H40a.75.75 0 0 1 .75.75v.75m16.5 0v-.75A.75.75 0 0 1 58 21h.75m-1.5 1.5h-16.5m11.25-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H55V16.5Zm-12 0h.008v.008H43V16.5Z",
    stroke: "url(#b)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.26 48v-9.184h2.87c.625 0 1.18.084 1.666.252.485.159.863.43 1.134.812.28.373.42.877.42 1.512 0 .71-.187 1.283-.56 1.722-.373.43-.877.723-1.512.882L41.616 48H40.3l-2.212-3.878h-1.666V48H35.26Zm1.162-4.83h1.54c.719 0 1.27-.145 1.652-.434.383-.299.574-.747.574-1.344 0-.607-.191-1.031-.574-1.274-.383-.243-.933-.364-1.652-.364h-1.54v3.416Zm9.418 4.998c-.607 0-1.157-.14-1.652-.42-.495-.29-.887-.7-1.176-1.232-.29-.532-.434-1.167-.434-1.904 0-.747.145-1.386.434-1.918.299-.532.681-.943 1.148-1.232.467-.29.957-.434 1.47-.434.868 0 1.535.29 2.002.868.476.579.714 1.353.714 2.324 0 .121-.005.243-.014.364 0 .112-.01.21-.028.294h-4.592c.047.719.27 1.293.672 1.722.41.43.943.644 1.596.644.327 0 .625-.047.896-.14a4.22 4.22 0 0 0 .798-.392l.406.756c-.29.187-.62.35-.994.49-.364.14-.78.21-1.246.21Zm-2.142-4.116h3.64c0-.69-.15-1.213-.448-1.568-.29-.364-.7-.546-1.232-.546-.476 0-.905.187-1.288.56-.373.364-.597.882-.672 1.554ZM50.323 48v-5.866H49.4v-.868l.924-.07v-1.078c0-.69.159-1.237.476-1.638.327-.41.831-.616 1.512-.616.215 0 .42.023.616.07.196.037.369.089.518.154l-.252.882a1.879 1.879 0 0 0-.77-.168c-.634 0-.952.439-.952 1.316v1.078h1.442v.938h-1.442V48h-1.148Zm3.992 0v-6.804h1.148V48h-1.148Zm.588-8.204a.82.82 0 0 1-.56-.196c-.14-.14-.21-.327-.21-.56 0-.224.07-.406.21-.546.15-.14.336-.21.56-.21.224 0 .406.07.546.21.15.14.224.322.224.546 0 .233-.075.42-.224.56a.768.768 0 0 1-.546.196Zm4.175 8.372c-.429 0-.742-.13-.938-.392-.186-.27-.28-.653-.28-1.148v-8.596h1.148v8.68c0 .177.033.308.098.392.066.075.14.112.224.112h.099c.037-.01.088-.019.154-.028l.154.868a.993.993 0 0 1-.267.084 2.253 2.253 0 0 1-.392.028Zm3.669 0c-.43 0-.742-.13-.938-.392-.187-.27-.28-.653-.28-1.148v-8.596h1.148v8.68c0 .177.032.308.098.392.065.075.14.112.224.112h.098c.037-.01.088-.019.154-.028l.154.868a.994.994 0 0 1-.266.084 2.254 2.254 0 0 1-.392.028Z",
    fill: "#FFF659"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 49,
    y1: 0,
    x2: 49,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF659"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 49,
    y1: 10.5,
    x2: 49,
    y2: 26.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF559"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefil);
export default __webpack_public_path__ + "static/media/refil.57f00b7657bd2067f12a31d3343771f6.svg";
export { ForwardRef as ReactComponent };